import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import Modal from 'components/ui/Modal'
import MultiStepForm from 'components/ui/form/MultiStepForm'
import ValidationStatusContext from 'components/dashboard/integrations/components/ValidationStatusContext'
import {
    submitFedexRegistrationData,
    submitFedexRestRegistrationData,
    useCarrierManagement,
} from 'components/dashboard/integrations/carrierManagement'
import { useCarrierWizardClose } from 'components/dashboard/integrations/containers/CarrierWizard/components/hooks/useCarrierWizardClose'

import { useWizardSteps } from './hooks/use-wizard-steps'
import { MarketplaceDetailsCTA } from './MarketplaceDetailsCTA'

const noop = () => undefined

export const FedexWizard = ({ onClose = noop }) => {
    const { replaceCredentials } = useContext(ValidationStatusContext)

    const context = useCarrierManagement()
    const {
        isMarketplace,
    } = context

    const fedexLegacyRegistration = useSelector(
        ({ app: { fedex_legacy_registration } }: any) => fedex_legacy_registration
    )

    const { modalVisible, setModalVisible, handleClose } =
        useCarrierWizardClose(onClose, replaceCredentials)

    const steps = useWizardSteps({ handleClose })

    const initialStep = replaceCredentials ? 1 : 0

    const handleValidationSubmit = async (data) => {
        if (fedexLegacyRegistration) {
            await submitFedexRegistrationData(context, data)
        } else {
            await submitFedexRestRegistrationData(context, data)
        }
    }

    return (
        <>
            {isMarketplace && (
                <MarketplaceDetailsCTA
                    showModal={() => setModalVisible(true)}
                />
            )}

            {modalVisible && (
                <div data-testid="fedex-wizard">
                    <Modal
                        modalName="mp-install"
                        captureNotifications={false}
                        onClose={handleClose}
                        className="modal-content install-app"
                        hidden={!modalVisible}
                    >
                        <MultiStepForm
                            id="fedex-form"
                            trackingKey="mp-install"
                            onSubmit={handleValidationSubmit}
                            dontPersist
                            disableAutocomplete
                            initialStep={initialStep}
                        >
                            {steps}
                        </MultiStepForm>
                    </Modal>
                </div>
            )}
        </>
    )
}

FedexWizard.defaultProps = {
    onClose: () => undefined,
}
